import { createAsyncThunk } from '@reduxjs/toolkit';

function getUserRegistrationsNew({ search }, { extra: { http } }) {
  return http.get(`/user_registrations/new${search}`);
}
function postUserRegistrations({ search, user }, { extra: { http } }) {
  return http.post(`/user_registrations${search}`, { user });
}

function getSSOOptions(_, { extra: { http } }) {
  return http.get('/saml/sso_logins');
}

export const newSignup = createAsyncThunk(
  'user_registrations/new',
  getUserRegistrationsNew
);
export const createSignup = createAsyncThunk(
  'user_registrations/create',
  postUserRegistrations
);

export const getAvailableSSOOptions = createAsyncThunk(
  'user_registrations/sso_options',
  getSSOOptions
);
